<template>
  <div>
    <h2 class="text-xl font-semibold mb-4">Köparens uppgifter</h2>
    <form @submit.prevent="handleNext">
      <input
        v-model="localBuyer.name"
        placeholder="Namn"
        class="input mb-2"
        required
      />
      <input
        v-model="localBuyer.email"
        type="email"
        placeholder="E-post"
        class="input mb-2"
        required
      />
      <input
        v-model="localBuyer.phone"
        type="tel"
        placeholder="Telefonnummer"
        class="input mb-2"
        required
      />

      <div class="flex justify-between mt-4">
        <button
          class="px-4 py-2 bg-gray-200 rounded"
          @click="$emit('back')"
        >
          Tillbaka
        </button>
        <button
          type="submit"
          class="px-4 py-2 bg-indigo-600 text-white rounded"
        >
          Nästa
        </button>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  props: {
    buyer: {
      type: Object,
      default: () => ({ name: '', email: '', phone: '' })
    }
  },
  data() {
    return {
      localBuyer: { ...this.buyer }
    };
  },
  methods: {
    handleNext() {
      // Emit the updated buyer data
      this.$emit('update-buyer', this.localBuyer);
      this.$emit('next');
    }
  }
};
</script>
